import React, { useState, useEffect, useCallback } from 'react';
import { format, parseISO } from 'date-fns';
import ReportLayout, { ReportTable, usePagination, fmtId } from './ReportLayout';
import { ReportChartRow, BarCard, DonutCard, groupCount, expiryBuckets, EXPIRY_COLORS } from './ReportCharts';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import clsx from 'clsx';

const fmtDate = v => { try { return v ? format(parseISO(v), 'd MMM yyyy') : '–'; } catch { return v||'–'; } };

const COLS = [
  { key:'document_id', label:'Document ID', render: fmtId },
  { key:'client_id',   label:'Client ID',   render: fmtId },
  { key:'client',      label:'Client' },
  { key:'file_name',   label:'File Name' },
  { key:'expiry_date', label:'Expires At', render: (v) => {
    const expired = v && new Date(v) < new Date();
    return <span className={clsx('font-medium', expired ? 'text-red-600' : 'text-amber-600')}>{fmtDate(v)}</span>;
  }},
  { key:'category',    label:'Category' },
  { key:'created_at',  label:'Created At', render: fmtDate },
  { key:'updated_at',  label:'Updated At', render: fmtDate },
];

export default function ClientDocumentExpiry() {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const today = new Date().toISOString().split('T')[0];
  const [startDate, setStart] = useState(today);
  const [endDate, setEnd]     = useState(new Date(Date.now()+60*86400000).toISOString().split('T')[0]);
  const pagination = usePagination(data);

  const load = useCallback(() => {
    setLoading(true);
    api.get(`/reports/client-document-expiry?start_date=${startDate}&end_date=${endDate}`)
      .then(r => { setData(r.data||[]); pagination.reset(); })
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, [startDate, endDate]);

  useEffect(() => { load(); }, [load]);

  const chips = [{ label:'Date Range', value:`${startDate} - ${endDate}` }];

  return (
    <ReportLayout title="Client Document Expiry" data={data} filename="client_document_expiry" columns={COLS}
      activeChips={chips} showFiltersPanel={showFilters} onToggleFilters={() => setShowFilters(v=>!v)}
      chart={
        <ReportChartRow>
          <DonutCard title="Expiry status" data={expiryBuckets(data)} colors={EXPIRY_COLORS} />
          <BarCard title="By category" data={groupCount(data, 'category')} />
        </ReportChartRow>
      }
      filters={
        <div className="flex flex-wrap gap-4">
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">From</label>
            <input type="date" value={startDate} onChange={e => setStart(e.target.value)} className="input-field !w-auto text-sm"/></div>
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">To</label>
            <input type="date" value={endDate} onChange={e => setEnd(e.target.value)} className="input-field !w-auto text-sm"/></div>
          <div className="flex items-end"><button onClick={load} className="btn-primary text-sm px-4 py-2">Apply</button></div>
        </div>
      }>
      <ReportTable columns={COLS} data={data} loading={loading} pagination={pagination}/>
    </ReportLayout>
  );
}
